import { useEffect, useLayoutEffect, useState } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from 'react-router-dom';
import {
  Login,
  Dashboard,
  Service,
  Announcements,
  Dogs,
  Users,
  Appointments,
  Income,
  Tips,
  Logs,
  Medication,
} from '../pages/pages';
import { getUserInfo } from '../helpers/helpers';
import { Result } from 'antd';

function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const [user, setUser] = useState(getUserInfo()?.id);

  const ProtectedRoute = ({ user, children }) => {
    if (!user) {
      return <Navigate to="/" />;
    }
    return children;
  };

  const LoginCheck = ({ children }) => {
    if (getUserInfo()?.id) {
      return <Navigate to="/dashboard" />;
    }
    return children;
  };

  useEffect(() => {
    setAuthUser();
  }, []);

  const setAuthUser = auth => {
    const id = getUserInfo()?.id;
    setUser(auth || id);
  };
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path="/"
          element={
            <LoginCheck>
              <Login setAuthUser={setAuthUser} />
            </LoginCheck>
          }
        />
        <Route
          exact
          path="/dashboard"
          element={
            <ProtectedRoute user={user}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/service"
          element={
            <ProtectedRoute user={user}>
              <Service />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/announcements"
          element={
            <ProtectedRoute user={user}>
              <Announcements />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/owners"
          element={
            <ProtectedRoute user={user}>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/dogs"
          element={
            <ProtectedRoute user={user}>
              <Dogs />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/appointments"
          element={
            <ProtectedRoute user={user}>
              <Appointments />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/income"
          element={
            <ProtectedRoute user={user}>
              <Income />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/tips"
          element={
            <ProtectedRoute user={user}>
              <Tips />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/logs"
          element={
            <ProtectedRoute user={user}>
              <Logs />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/medication"
          element={
            <ProtectedRoute user={user}>
              <Medication />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="*"
          element={
            <Result
              status="404"
              title="404"
              subTitle="Sorry, the page you visited does not exist."
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
